export interface VideoItem {
  id: string;
  title: string;
  cover: string;
  category: string;
  categorySlug: string;
  tags: string[];
  rating: number;
  year: string;
  region: string;
  description: string;
  updateInfo: string;
  episodeCount: string;
  isHot: boolean;
  isNew: boolean;
}

export interface VideoCategory {
  name: string;
  slug: string;
  icon: string;
}

export const videoCategories: VideoCategory[] = [
  { name: '热门推荐', slug: 'hot', icon: 'ri-fire-line' },
  { name: '电视剧', slug: 'tv-series', icon: 'ri-tv-line' },
  { name: '电影', slug: 'movie', icon: 'ri-film-line' },
  { name: '综艺', slug: 'variety', icon: 'ri-live-line' },
  { name: '动漫', slug: 'anime', icon: 'ri-ghost-line' },
  { name: '纪录片', slug: 'documentary', icon: 'ri-camera-line' },
];

export const videos: VideoItem[] = [
  {
    id: 'v001',
    title: '长安十二时辰',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20poster%20Tang%20Dynasty%20aesthetic%2C%20ancient%20Chinese%20cityscape%20at%20night%20with%20lanterns%2C%20mysterious%20warrior%20silhouette%2C%20cinematic%20lighting%2C%20warm%20gold%20and%20red%20tones%2C%20epic%20composition%2C%20clean%20centered%20design%20against%20dark%20background&width=640&height=900&seq=taohua-video-cover-001&orientation=portrait',
    category: '电视剧',
    categorySlug: 'tv-series',
    tags: ['古装', '悬疑', '历史'],
    rating: 8.5,
    year: '2024',
    region: '中国大陆',
    description: '唐朝天宝三年，上元节前夕，长安城陷入危机。死囚张小敬临危受命，与少年名士李必携手在十二时辰内拯救长安。',
    updateInfo: '更新至48集全',
    episodeCount: '48集全',
    isHot: true,
    isNew: false,
  },
  {
    id: 'v002',
    title: '流浪地球3',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%2C%20futuristic%20space%20station%20with%20Earth%20in%20background%2C%20astronaut%20helmet%20reflection%2C%20dramatic%20cosmic%20lighting%2C%20deep%20space%20nebula%20colors%2C%20cinematic%20blockbuster%20style%2C%20centered%20heroic%20composition%20on%20dark%20background&width=640&height=900&seq=taohua-video-cover-002&orientation=portrait',
    category: '电影',
    categorySlug: 'movie',
    tags: ['科幻', '灾难', '冒险'],
    rating: 8.9,
    year: '2025',
    region: '中国大陆',
    description: '太阳急速老化，持续膨胀。人类面临前所未有的生存危机，全球各国联合启动"流浪地球"计划，带着地球去流浪。',
    updateInfo: '2025-07-28 上映',
    episodeCount: '1部',
    isHot: true,
    isNew: true,
  },
  {
    id: 'v003',
    title: '乘风破浪的姐姐 第五季',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%2C%20elegant%20women%20in%20stunning%20dresses%20on%20stage%2C%20spotlight%20effect%2C%20glamorous%20performance%20atmosphere%2C%20fashionable%20and%20chic%2C%20warm%20golden%20stage%20lighting%2C%20centered%20group%20composition%20on%20dark%20background&width=640&height=900&seq=taohua-video-cover-003&orientation=portrait',
    category: '综艺',
    categorySlug: 'variety',
    tags: ['音乐', '竞演', '女性'],
    rating: 8.2,
    year: '2025',
    region: '中国大陆',
    description: '三十位30+女艺人突破自我，在舞台上绽放光芒。她们用实力证明，年龄从来不是限制，每个阶段都可以乘风破浪。',
    updateInfo: '每周五更新',
    episodeCount: '更新至第8期',
    isHot: true,
    isNew: false,
  },
  {
    id: 'v004',
    title: '斗破苍穹 年番',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20donghua%20poster%2C%20martial%20arts%20fantasy%20young%20hero%20with%20flaming%20aura%2C%20ancient%20Chinese%20palace%20and%20mountains%2C%20dynamic%20action%20pose%2C%20epic%20fantasy%20illustration%20style%2C%20vibrant%20warm%20colors%2C%20centered%20character%20composition&width=640&height=900&seq=taohua-video-cover-004&orientation=portrait',
    category: '动漫',
    categorySlug: 'anime',
    tags: ['玄幻', '热血', '战斗'],
    rating: 9.1,
    year: '2025',
    region: '中国大陆',
    description: '萧炎，昔日天才少年，如今沦为废人。在遭受无数冷眼与嘲讽后，他凭借坚韧不拔的意志，一步步走向巅峰。',
    updateInfo: '更新至156集',
    episodeCount: '156集',
    isHot: true,
    isNew: false,
  },
  {
    id: 'v005',
    title: '河西走廊',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20documentary%20poster%2C%20ancient%20Silk%20Road%20landscape%20with%20vast%20desert%20and%20snow%20mountains%2C%20camel%20caravan%20silhouette%2C%20historical%20cultural%20heritage%20theme%2C%20epic%20cinematography%20style%2C%20warm%20earthy%20golden%20tones%2C%20widescreen%20composition&width=640&height=900&seq=taohua-video-cover-005&orientation=portrait',
    category: '纪录片',
    categorySlug: 'documentary',
    tags: ['历史', '地理', '文化'],
    rating: 9.7,
    year: '2025',
    region: '中国大陆',
    description: '以河西走廊为时空背景，梳理从汉代到中华人民共和国时期的河西走廊历史，展现丝绸之路的千年沧桑。',
    updateInfo: '更新至10集全',
    episodeCount: '10集全',
    isHot: false,
    isNew: true,
  },
  {
    id: 'v006',
    title: '狂飙',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20poster%2C%20intense%20police%20officer%20and%20gangster%20face-off%2C%20urban%20night%20cityscape%2C%20gritty%20realistic%20style%2C%20dramatic%20contrast%20lighting%2C%20suspenseful%20atmosphere%2C%20centered%20dual%20portrait%20composition%20on%20dark%20background&width=640&height=900&seq=taohua-video-cover-006&orientation=portrait',
    category: '电视剧',
    categorySlug: 'tv-series',
    tags: ['犯罪', '悬疑', '剧情'],
    rating: 9.4,
    year: '2024',
    region: '中国大陆',
    description: '以一线刑警安欣为代表的正义力量，与黑恶势力展开长达二十年的生死较量，全景式展现扫黑除恶的艰辛历程。',
    updateInfo: '更新至39集全',
    episodeCount: '39集全',
    isHot: true,
    isNew: false,
  },
  {
    id: 'v007',
    title: '满江红',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20suspense%20movie%20poster%2C%20Song%20Dynasty%20soldiers%20in%20ancient%20courtyard%2C%20red%20lanterns%20and%20shadows%2C%20mysterious%20atmosphere%2C%20dark%20crimson%20and%20black%20color%20palette%2C%20cinematic%20poster%20design%2C%20centered%20group%20composition&width=640&height=900&seq=taohua-video-cover-007&orientation=portrait',
    category: '电影',
    categorySlug: 'movie',
    tags: ['历史', '悬疑', '喜剧'],
    rating: 7.8,
    year: '2024',
    region: '中国大陆',
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。会谈前夜，金国使者死在宰相驻地，所携密信也不翼而飞。',
    updateInfo: '2024-01-22 上映',
    episodeCount: '1部',
    isHot: false,
    isNew: false,
  },
  {
    id: 'v008',
    title: '向往的生活 第八季',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20reality%20show%20poster%2C%20peaceful%20countryside%20farmhouse%20with%20green%20fields%2C%20warm%20sunset%20light%2C%20cozy%20rural%20lifestyle%20theme%2C%20natural%20organic%20feel%2C%20soft%20golden%20hour%20photography%2C%20centered%20house%20and%20nature%20composition&width=640&height=900&seq=taohua-video-cover-008&orientation=portrait',
    category: '综艺',
    categorySlug: 'variety',
    tags: ['生活', '慢综艺', '美食'],
    rating: 8.0,
    year: '2025',
    region: '中国大陆',
    description: '黄磊、何炅携手新老好友，回归田园生活。在一方小院中，自给自足，招待远道而来的朋友，讲述温暖人心的故事。',
    updateInfo: '每周六更新',
    episodeCount: '更新至第6期',
    isHot: false,
    isNew: true,
  },
  {
    id: 'v009',
    title: '一人之下 第五季',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20donghua%20supernatural%20martial%20arts%20poster%2C%20modern%20urban%20fantasy%20young%20fighters%20with%20energy%20powers%2C%20dynamic%20action%20scene%2C%20Chinese%20comic%20art%20style%2C%20vibrant%20colors%20with%20contrast%2C%20centered%20character%20group%20composition&width=640&height=900&seq=taohua-video-cover-009&orientation=portrait',
    category: '动漫',
    categorySlug: 'anime',
    tags: ['奇幻', '战斗', '热血'],
    rating: 9.0,
    year: '2025',
    region: '中国大陆',
    description: '张楚岚在异人世界的冒险继续。随着甲申之乱的真相逐渐揭开，各方势力蠢蠢欲动，一场更大的风暴即将来临。',
    updateInfo: '更新至24集全',
    episodeCount: '24集全',
    isHot: true,
    isNew: false,
  },
  {
    id: 'v010',
    title: '舌尖上的中国 第四季',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20poster%2C%20beautiful%20traditional%20Chinese%20cuisine%20close-up%2C%20steaming%20hot%20dishes%20on%20wooden%20table%2C%20warm%20kitchen%20atmosphere%2C%20appetizing%20food%20photography%2C%20rich%20warm%20colors%2C%20centered%20food%20composition%20on%20dark%20background&width=640&height=900&seq=taohua-video-cover-010&orientation=portrait',
    category: '纪录片',
    categorySlug: 'documentary',
    tags: ['美食', '文化', '人文'],
    rating: 9.3,
    year: '2025',
    region: '中国大陆',
    description: '从食材的获取到烹饪的技巧，从地方风味的传承到饮食文化的变迁，讲述中国人与食物之间最动人的故事。',
    updateInfo: '更新至8集全',
    episodeCount: '8集全',
    isHot: false,
    isNew: true,
  },
  {
    id: 'v011',
    title: '三体',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20TV%20series%20poster%2C%20three-body%20problem%20cosmic%20theme%2C%20mysterious%20alien%20civilization%20symbol%2C%20deep%20space%20with%20stars%2C%20mind-bending%20conceptual%20design%2C%20dark%20and%20gold%20contrast%2C%20centered%20abstract%20cosmic%20composition&width=640&height=900&seq=taohua-video-cover-011&orientation=portrait',
    category: '电视剧',
    categorySlug: 'tv-series',
    tags: ['科幻', '悬疑', '剧情'],
    rating: 8.7,
    year: '2024',
    region: '中国大陆',
    description: '纳米科学家汪淼被警官史强带入神秘的"科学边界"组织，共同揭开地外文明"三体"世界的神秘面纱。',
    updateInfo: '更新至30集全',
    episodeCount: '30集全',
    isHot: true,
    isNew: false,
  },
  {
    id: 'v012',
    title: '封神第二部',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20fantasy%20movie%20poster%2C%20ancient%20Chinese%20gods%20and%20warriors%20epic%20battle%2C%20mythical%20creatures%20and%20magical%20weapons%2C%20grand%20scale%20cinematic%2C%20dramatic%20golden%20and%20crimson%20lighting%2C%20centered%20heroic%20composition&width=640&height=900&seq=taohua-video-cover-012&orientation=portrait',
    category: '电影',
    categorySlug: 'movie',
    tags: ['奇幻', '神话', '史诗'],
    rating: 8.3,
    year: '2025',
    region: '中国大陆',
    description: '殷商末年，纣王暴虐无道。姜子牙携封神榜下山，辅佐武王伐纣。一场人、仙、妖三界的宏大战争就此展开。',
    updateInfo: '2025-01-29 上映',
    episodeCount: '1部',
    isHot: true,
    isNew: true,
  },
  {
    id: 'v013',
    title: '明星大侦探 第九季',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20detective%20variety%20show%20poster%2C%20mysterious%20crime%20scene%20investigation%20theme%2C%20magnifying%20glass%20and%20clues%2C%20suspenseful%20atmosphere%2C%20dark%20moody%20lighting%20with%20warm%20accents%2C%20centered%20mystery%20composition&width=640&height=900&seq=taohua-video-cover-013&orientation=portrait',
    category: '综艺',
    categorySlug: 'variety',
    tags: ['推理', '悬疑', '喜剧'],
    rating: 8.8,
    year: '2025',
    region: '中国大陆',
    description: '明星玩家化身侦探，在精心布置的案件现场寻找线索，通过缜密推理揭开真相。烧脑与搞笑并存，悬疑与娱乐兼具。',
    updateInfo: '每周四更新',
    episodeCount: '更新至第10期',
    isHot: false,
    isNew: true,
  },
  {
    id: 'v014',
    title: '深海',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20film%20poster%2C%20dreamlike%20underwater%20world%20with%20colorful%20jellyfish%20and%20coral%2C%20young%20girl%20swimming%20in%20deep%20ocean%2C%20magical%20surreal%20atmosphere%2C%20vibrant%20ink%20wash%20painting%20style%2C%20centered%20fantasy%20composition&width=640&height=900&seq=taohua-video-cover-014&orientation=portrait',
    category: '动漫',
    categorySlug: 'anime',
    tags: ['奇幻', '治愈', '冒险'],
    rating: 8.1,
    year: '2024',
    region: '中国大陆',
    description: '一个沉溺于悲伤中的女孩参宿，误入了一个由她内心世界构建的奇幻深海世界，在那里她遇到了一个神秘少年南河。',
    updateInfo: '1部',
    episodeCount: '1部',
    isHot: false,
    isNew: false,
  },
  {
    id: 'v015',
    title: '地球脉动 第三季',
    cover: 'https://readdy.ai/api/search-image?query=BBC%20nature%20documentary%20poster%2C%20stunning%20wildlife%20photography%20penguins%20and%20polar%20bears%2C%20Earth%20from%20space%20view%2C%20breathtaking%20natural%20landscapes%2C%20epic%20cinematography%20style%2C%20vibrant%20natural%20colors%2C%20centered%20planet%20Earth%20composition&width=640&height=900&seq=taohua-video-cover-015&orientation=portrait',
    category: '纪录片',
    categorySlug: 'documentary',
    tags: ['自然', '动物', '地理'],
    rating: 9.8,
    year: '2025',
    region: '英国',
    description: '从深海到高山，从极地到沙漠，用最先进的拍摄技术，展现地球上最壮观的自然奇观和野生动物生存故事。',
    updateInfo: '更新至8集全',
    episodeCount: '8集全',
    isHot: false,
    isNew: false,
  },
  {
    id: 'v016',
    title: '庆余年 第二季',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20drama%20poster%2C%20handsome%20scholar%20in%20ancient%20Chinese%20robe%20with%20fan%2C%20imperial%20palace%20background%2C%20political%20intrigue%20theme%2C%20elegant%20warm%20golden%20lighting%2C%20centered%20character%20portrait%20composition&width=640&height=900&seq=taohua-video-cover-016&orientation=portrait',
    category: '电视剧',
    categorySlug: 'tv-series',
    tags: ['古装', '权谋', '喜剧'],
    rating: 9.2,
    year: '2025',
    region: '中国大陆',
    description: '范闲从北齐归来后，发现庆国朝堂暗流涌动。面对各方势力的角逐，他必须在权力与道义之间做出自己的选择。',
    updateInfo: '更新至36集全',
    episodeCount: '36集全',
    isHot: true,
    isNew: true,
  },
  {
    id: 'v017',
    title: '哪吒之魔童闹海',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20animated%20movie%20poster%2C%20young%20rebellious%20Nezha%20character%20with%20fire%20wheels%20and%20red%20sash%2C%20epic%20stormy%20sea%20battle%20scene%2C%20dynamic%20Chinese%20animation%20style%2C%20vibrant%20red%20and%20gold%20colors%2C%20centered%20heroic%20composition&width=640&height=900&seq=taohua-video-cover-017&orientation=portrait',
    category: '电影',
    categorySlug: 'movie',
    tags: ['动画', '神话', '冒险'],
    rating: 8.6,
    year: '2025',
    region: '中国大陆',
    description: '天劫之后，哪吒和敖丙的灵魂虽保住了，但肉身即将魂飞魄散。太乙真人打算用七色宝莲为二人重塑肉身。',
    updateInfo: '2025-07-25 上映',
    episodeCount: '1部',
    isHot: true,
    isNew: true,
  },
  {
    id: 'v018',
    title: '完美世界',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20donghua%20cultivation%20fantasy%20poster%2C%20young%20warrior%20with%20glowing%20energy%20in%20ancient%20fantasy%20world%2C%20floating%20islands%20and%20mystical%20beasts%2C%20epic%20Chinese%20fantasy%20illustration%2C%20vibrant%20warm%20golden%20and%20green%20tones%2C%20centered%20character%20composition&width=640&height=900&seq=taohua-video-cover-018&orientation=portrait',
    category: '动漫',
    categorySlug: 'anime',
    tags: ['玄幻', '修仙', '冒险'],
    rating: 8.9,
    year: '2025',
    region: '中国大陆',
    description: '石昊为救父母，踏上了前往上界的征途。在这个更加广阔的世界中，他将面对更强大的敌人和更大的挑战。',
    updateInfo: '更新至189集',
    episodeCount: '189集',
    isHot: true,
    isNew: false,
  },
];

export const banners = [
  {
    title: '流浪地球3',
    subtitle: '带着地球去流浪，人类命运共同体的壮丽史诗',
    category: '科幻大片',
    link: '/article/v002',
    cover: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20sci-fi%20movie%20scene%2C%20massive%20Earth%20engines%20propelling%20planet%20through%20space%2C%20futuristic%20space%20station%2C%20dramatic%20cosmic%20lighting%2C%20cinematic%20blockbuster%20visual%2C%20deep%20space%20nebula%20background%2C%20warm%20engine%20glow%20against%20dark%20cosmos&width=1600&height=700&seq=taohua-banner-001&orientation=landscape',
  },
  {
    title: '庆余年 第二季',
    subtitle: '权谋天下，谁主沉浮？范闲归来再掀风云',
    category: '古装权谋',
    link: '/article/v016',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20scene%2C%20ancient%20imperial%20palace%20courtyard%20at%20sunset%2C%20scholar%20looking%20at%20distant%20mountains%2C%20misty%20atmosphere%2C%20elegant%20traditional%20aesthetic%2C%20warm%20golden%20hour%20lighting%2C%20cinematic%20widescreen%20composition&width=1600&height=700&seq=taohua-banner-002&orientation=landscape',
  },
  {
    title: '哪吒之魔童闹海',
    subtitle: '我命由我不由天！哪吒归来，魔童闹海',
    category: '动画巨制',
    link: '/article/v017',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20animated%20film%20epic%20scene%2C%20young%20warrior%20riding%20on%20waves%20with%20fire%20and%20lightning%2C%20stormy%20ocean%20with%20dramatic%20sky%2C%20Chinese%20mythology%20style%2C%20vibrant%20red%20and%20gold%20color%20palette%2C%20cinematic%20widescreen&width=1600&height=700&seq=taohua-banner-003&orientation=landscape',
  },
];

export const siteInfo = {
  name: '桃花视频',
  url: 'https://taohuavideo.com',
  description: '桃花视频网聚合红桃视频、樱桃视频、茄子视频、糖心视频等平台资源，高清免费在线观看，电视剧全集、电影大全实时更新，流畅不卡顿，最新热播剧一站看全。',
  keywords: '桃花视频,红桃视频,樱桃视频,茄子视频,糖心视频,免费在线观看,高清全集,不缓冲,榴莲视频,桃子视频,最新电视剧,电影大全',
};